(async () => {
  const section = document.querySelector(".js-collection-products");
  const cartDrawer = document.querySelector("cart-drawer");
  if (!section) return;

  const filters = document.querySelector('.js-collection-products__filters');

  function updateFiltersAlignment() {
    if (!filters) return;

    if (filters.scrollWidth > filters.clientWidth) {
      filters.classList.add('scrollable');
    } else {
      filters.classList.remove('scrollable');
    }
  }

  function isMobileOrTabletViewport() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function isHorizontallyFullyVisible(container, element) {
    const containerRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();

    return elementRect.left >= containerRect.left && elementRect.right <= containerRect.right;
  }

  function scrollActiveFilterIntoView(behavior = 'smooth') {
    if (!filters) return;
    if (!isMobileOrTabletViewport()) return;
    if (filters.scrollWidth <= filters.clientWidth) return;

    const activeFilter = filters.querySelector('.js-collection-products__filter-btn.is-active');
    if (!activeFilter) return;
    if (isHorizontallyFullyVisible(filters, activeFilter)) return;

    activeFilter.scrollIntoView({
      behavior,
      inline: 'center',
      block: 'nearest',
    });
  }

  window.addEventListener('load', updateFiltersAlignment);
  window.addEventListener('resize', updateFiltersAlignment);

  section.addEventListener("submit", (e) => {
    const form = e.target;
    if (form.tagName !== "FORM" || !form.action?.includes("/cart/add")) return;

    const btn = form.querySelector(".js-collection-products__button");
    if (!btn) return;

    e.preventDefault();
    if (btn.getAttribute("aria-disabled") === "true") return;
    btn.setAttribute("aria-disabled", "true");

    const formData = new FormData(form);
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
      const sectionIds = cartDrawer.getSectionsToRender().map((s) => s.id);
      formData.append("sections", sectionIds.join(","));
      formData.append("sections_url", window.location.pathname);
      cartDrawer.setActiveElement?.(document.activeElement);
    }

    const fetchOptions =
      typeof fetchConfig === "function"
        ? fetchConfig("javascript")
        : { method: "POST" };
    fetchOptions.headers = fetchOptions.headers || {};
    fetchOptions.headers["X-Requested-With"] = "XMLHttpRequest";
    delete fetchOptions.headers["Content-Type"];
    fetchOptions.body = formData;

    const url = window.routes?.cart_add_url || "/cart/add.js";
    fetch(url, fetchOptions)
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          const errEl =
            section.querySelector(".collection-products__error") ||
            document.getElementById("CartDrawer-CartErrors");
          if (errEl && window.cartStrings?.error) {
            errEl.textContent = data.description || window.cartStrings.error;
          }
          btn.removeAttribute("aria-disabled");
          return;
        }
        if (
          cartDrawer &&
          typeof cartDrawer.renderContents === "function" &&
          data.sections
        ) {
          cartDrawer.renderContents(data);
        }
        btn.removeAttribute("aria-disabled");
      })
      .catch(() => btn.removeAttribute("aria-disabled"));
  });

  const filterBtns = section.querySelectorAll(".js-collection-products__filter-btn");
  const cards = section.querySelectorAll(".js-collection-products__card");
  const tiles = section.querySelectorAll(".js-collection-products__tile");

  function getFilterFromURL() {
    return new URLSearchParams(window.location.search).get("filter") || "all";
  }

  function applyFilter(value) {
    filterBtns.forEach((btn) => {
      const isActive = btn.dataset.filter === value;
      btn.classList.toggle("is-active", isActive);
      btn.setAttribute("aria-selected", isActive);
    });

    tiles.forEach((tile) => {
      tile.hidden = value !== "all";
    });

    cards.forEach((card) => {
      if (value === "all") {
        card.removeAttribute("hidden");
        return;
      }
      const tags = (card.dataset.filterTags || "").split(",");
      const match = tags.some((t) => t.trim() === value);
      if (match) {
        card.removeAttribute("hidden");
      } else {
        card.setAttribute("hidden", "");
      }
    });

    window.requestAnimationFrame(() => {
      updateFiltersAlignment();
      scrollActiveFilterIntoView();
    });
  }

  function updateURL(value) {
    const url = new URL(window.location.href);
    if (value === "all") {
      url.searchParams.delete("filter");
    } else {
      url.searchParams.set("filter", value);
    }
    history.pushState({ filter: value }, "", url.toString());
  }

  filterBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const value = btn.dataset.filter;
      applyFilter(value);
      updateURL(value);
    });
  });

  window.addEventListener("popstate", () => {
    applyFilter(getFilterFromURL());
  });

  applyFilter(getFilterFromURL());

  window.addEventListener('load', () => {
    window.requestAnimationFrame(() => {
      updateFiltersAlignment();
      scrollActiveFilterIntoView('auto');
    });
  });

  const imageWraps = section.querySelectorAll(".js-collection-products__image-wrap");

  imageWraps.forEach((wrap) => {
    const front = wrap.querySelector(".js-collection-products__image--front");
    const back = wrap.querySelector(".js-collection-products__image--back");

    if (!front || !back) return;

    wrap.addEventListener("mouseenter", () => {
      front.style.opacity = "0";
      back.style.opacity = "1";
    });

    wrap.addEventListener("mouseleave", () => {
      front.style.opacity = "1";
      back.style.opacity = "0";
    });
  });
})();
